module.exports = __webpack_public_path__ + "img/folder.e2abae65.svg";